export function getDivisionLabel(divisionAbbreviation: string): string {
  switch (divisionAbbreviation) {
    case "FL": {
      return "Florida";
    }
    case "TX": {
      return "Texas";
    }
    case "SE": {
      return "Southeast";
    }
    case "PR": {
      return "Puerto Rico";
    }
    default: {
      return divisionAbbreviation;
    }
  }
}

export function getHeaderDivisionBadgeLabel(
  divisionAbbreviation: string | undefined
): string | undefined {
  switch (divisionAbbreviation) {
    case "FL": {
      return "Florida";
    }
    case "TX": {
      return "Texas";
    }
    case "SE": {
      return "Southeast";
    }
    default: {
      return undefined;
    }
  }
}
